import { Navigate, Outlet, type To } from 'react-router-dom';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { isRATenantId } from '@shared/utils/tenant';

// RealAdvisor tenants only. Wraps the /v2 pages together with AdminRoute: they
// are RealAdvisor's internal previews, not something another tenant's user
// should reach by pasting a URL.
export const RATenantRoute: React.FC<{ redirectTo?: To }> = ({
  redirectTo,
}) => {
  const { me } = useAppData();

  return isRATenantId(me?.tenant_id ?? '') ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo ?? '/dashboard'} replace />
  );
};
